import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltRecorderControlPanelActionBarTogglePlayWireframe from './VeltRecorderControlPanelActionBarTogglePlayWireframe/VeltRecorderControlPanelActionBarTogglePlayWireframe';
var VeltRecorderControlPanelActionBarToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelActionBarToggleWireframe.Pause = VeltRecorderControlPanelActionBarTogglePlayWireframe;
VeltRecorderControlPanelActionBarToggleWireframe.Play = VeltRecorderControlPanelActionBarTogglePlayWireframe;
export default VeltRecorderControlPanelActionBarToggleWireframe;
